export type DeviceActivationSupport = "supported" | "unsupported" | "unknown";

export interface DeviceActivationSupportInput {
    make?: string;
    model?: string;
}

const normalize = (value?: string): string => (value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");

export function resolveDeviceActivationSupport(
    device: DeviceActivationSupportInput | undefined,
    supportedDevices: string[] | undefined,
): DeviceActivationSupport {
    if (!supportedDevices?.length) return "unknown";

    if (!device?.make || !device?.model) return "unknown";

    const key = normalize([device.make, device.model].join(" "));
    if (!key) return "unknown";

    return supportedDevices.some((entry) => entry && key.includes(normalize(entry))) ? "supported" : "unsupported";
}
